import { logPageView } from '@office-start/telemetry-service';
import { useEffect } from 'react';
export var useLogPageView = function (_a) {
    var pageName = _a.pageName, _b = _a.isIntentional, isIntentional = _b === void 0 ? true : _b;
    useEffect(function () {
        // If page name is not passed, logPageView will try to determine
        // the page name from the current route.
        logPageView({
            pageName: pageName,
            isIntentional: isIntentional,
        });
    }, [isIntentional, pageName]);
};
//# sourceMappingURL=useLogPageView.js.map